import { createAsyncThunk } from '@reduxjs/toolkit'
import getMemberLite from '../../api/getMemberLite'
import REQUEST_STATUS from '../common/REQUEST_STATUS'
import { asyncPendingReducer, asyncRejectedReducer } from '../common/defaultReducers'
import { mapToSegments } from '../mapping/mapToSegments'

export const fetchMemberLite = createAsyncThunk(
  'compass/member/fetch',
  async ({ compassMemberId, compassId, pin }) => {
    return await getMemberLite(compassMemberId, compassId, pin)
  }
)

export const fetchMemberLiteReducer = {
  [fetchMemberLite.pending]: (state) => asyncPendingReducer(state),
  [fetchMemberLite.fulfilled]: (state, action) => {
    state.context.prePopId.value = action.payload.prepopId
    state.context.appDataRequestStatus = REQUEST_STATUS.SUCCEEDED
    const payload = {
      ...action.payload,
      coverageAmount: action.payload.coverage,
      employee: {
        ...action.payload.employee,
        employment: action.payload.employment
      }
    }
    mapToSegments(state, payload)
  },
  [fetchMemberLite.rejected]: (state, action) => {
    asyncRejectedReducer(state, action)
    throw Error(action.error.message)
  }
}